import { Form, Formik } from 'formik';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { Button, Column, Row, Text } from '@wunder-mobility/ui-components';
import React, { FC } from 'react';
import AcceptTermsAndConditions from '@/features/auth/components/AcceptTermsAndConditions';
import { useRequestBranchTermsAndConditionsQuery } from '@/features/branches/services/Branches.service';
import DisclaimerText from '@/features/auth/components/DisclaimerText';
import { emailLoginSchema } from '@/features/auth/utils/validations/emailLogin.schema';

export interface EmailLoginFormValues {
  email: string;
  newsletterOptions?: any;
  code?: string;
  privacy?: boolean;
  terms?: boolean;
}

export interface EmailLoginFormProps {
  onSubmit: (values: EmailLoginFormValues) => Promise<void>;
  branchId?: number;
}

const EmailLoginForm: FC<EmailLoginFormProps> = ({ onSubmit, branchId }) => {
  const { data: branchTerms } = useRequestBranchTermsAndConditionsQuery(branchId!, {
    skip: !branchId,
  });

  return (
    <Formik
      initialValues={{ email: '', terms: false, privacy: false }}
      onSubmit={onSubmit}
      validationSchema={emailLoginSchema}
    >
      {({ isSubmitting, setTouched }) => {
        return (
          <Form>
            <Text
              fieldAttr={{
                id: 'email',
                placeholder: t({
                  id: 'account.basicInfo.emailPlaceholder',
                  message: 'E-mail address...',
                }),
                required: true,
              }}
              name="email"
              fieldProps={{
                size: 'large',
                label: t({
                  id: 'account.basicInfo.emailLabel',
                  message: 'E-mail address',
                }),
              }}
            />
            <AcceptTermsAndConditions
              termsAndConditionsUrl={branchTerms?.termsAndConditions!.termsAndConditionsUrl}
              privacyGuidelinesUrl={branchTerms?.termsAndConditions!.privacyGuidelinesUrl}
            />
            <DisclaimerText />

            <Row>
              <Column sm={12}>
                <Button
                  width="full"
                  size="large"
                  onClick={() => {
                    void setTouched({ terms: true, privacy: true });
                  }}
                  attributes={{ type: 'submit' }}
                  loading={isSubmitting}
                >
                  <Trans id="auth.emailLogin.submit">Send code</Trans>
                </Button>
              </Column>
            </Row>
          </Form>
        );
      }}
    </Formik>
  );
};

export default EmailLoginForm;
